export const GET_PROGRAMS_CATEGORIES = 'GET_PROGRAMS_CATEGORIES';
export const GET_PROGRAMS_CATEGORIES_LOADING = 'GET_PROGRAMS_CATEGORIES_LOADING';
export const GET_PROGRAMS_CATEGORIES_ERROR = 'GET_PROGRAMS_CATEGORIES_ERROR';

export const GET_PROGRAMS = 'GET_PROGRAMS';
export const GET_PROGRAMS_LOADING = 'GET_PROGRAMS_LOADING';
export const GET_PROGRAMS_ERROR = 'GET_PROGRAMS_ERROR';

export const GET_PROGRAM_BY_ID = 'GET_PROGRAM_BY_ID';
export const GET_PROGRAM_BY_ID_LOADING = 'GET_PROGRAM_BY_ID_LOADING';
export const GET_PROGRAM_BY_ID_ERROR = 'GET_PROGRAM_BY_ID_ERROR';

export const CREATE_PROGRAM = 'CREATE_PROGRAM';
export const CREATE_PROGRAM_LOADING = 'CREATE_PROGRAM_LOADING';
export const CREATE_PROGRAM_ERROR = 'CREATE_PROGRAM_ERROR';

export const CREATE_PROGRAMS_WITH_EXCEL = 'CREATE_PROGRAMS_WITH_EXCEL';
export const CREATE_PROGRAMS_WITH_EXCEL_LOADING = 'CREATE_PROGRAMS_WITH_EXCEL_LOADING';
export const CREATE_PROGRAMS_WITH_EXCEL_ERROR = 'CREATE_PROGRAMS_WITH_EXCEL_ERROR';

export const UPDATE_PROGRAM = 'UPDATE_PROGRAM';
export const UPDATE_PROGRAM_LOADING = 'UPDATE_PROGRAM_LOADING';
export const UPDATE_PROGRAM_ERROR = 'UPDATE_PROGRAM_ERROR';

export const DELETE_PROGRAM = 'DELETE_PROGRAM';
export const DELETE_PROGRAM_LOADING = 'DELETE_PROGRAM_LOADING';
export const DELETE_PROGRAM_ERROR = 'DELETE_PROGRAM_ERROR';
export const DELETE_PROGRAM_RESET_STATE = "DELETE_PROGRAM_RESET_STATE";

export const UPDATE_PROGRAM_STATUS = 'UPDATE_PROGRAM_STATUS';
export const UPDATE_PROGRAM_STATUS_LOADING = 'UPDATE_PROGRAM_STATUS_LOADING';
export const UPDATE_PROGRAM_STATUS_ERROR = 'UPDATE_PROGRAM_STATUS_ERROR';
export const UPDATE_PROGRAM_STATUS_RESET_STATE = "UPDATE_PROGRAM_STATUS_RESET_STATE";

export const PROGRAMS_RESET_STATE = "PROGRAMS_RESET_STATE";